import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../../environments/environment';

@Injectable()
export class AppSettingService {
    configUrl = "";
    constructor(private http: HttpClient) {
        this.configUrl = environment.configUrl;
    }

    getConfigurationById(id) {
        return this.http.get<any>(this.configUrl + "Configuration/" + id)
            .toPromise()
            .then(res => res);
    }

    addConfiguration(obj) {
        return this.http.post<any>(this.configUrl + "Configuration", obj)
            .toPromise()
            .then(res => res);
    }

    updateConfiguration(obj) {
        if (obj.id == 0) {
            return this.http.post<any>(this.configUrl + "Configuration", obj)
                .toPromise()
                .then(res => res);
        } else {

            return this.http.put<any>(this.configUrl + "Configuration", obj)
                .toPromise()
                .then(res => res);
        }
    }

    editConfiguration(obj) {
        return this.http.put<any>(this.configUrl + "Configuration/Edit", obj)
    }
}
